module.exports = __webpack_public_path__ + "img/phhero_img1.f87065bb.png";